module.exports = __webpack_public_path__ + "img/kerryexpress.c9c855a0.svg";